import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import { AsyncSearchSelect, FormField } from '@ideon-api/ideon-ui'
import { toOptionProps } from '../../common/ideon/formAdapters'

export class ZipFipsComponent extends Component {
  static propTypes = {
    getZipCounties: PropTypes.func.isRequired,
    value: PropTypes.string,
    requestInProgress: PropTypes.bool,
    zipCounties: PropTypes.array,
    handleChange: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  componentDidMount() {
    this.updateZipCountiesIfNeeded()
  }

  componentDidUpdate() {
    this.updateZipCountiesIfNeeded()
  }

  // AsyncSearchSelect calls onSearch immediately on open with an empty query,
  // so the 3-character floor has to live here rather than in a caller-side debounce.
  onSearch = async (query) => {
    if (query.length < 3) {
      return []
    }

    const records = await this.props.getZipCounties(query)

    return records.map((zc) => ({
      value: `${zc.zip_code}-${zc.fips_code}`,
      label: `${zc.zip_code} - ${zc.county_name}`
    }))
  }

  // Shows the raw "zip-fips" value immediately (before zipCounties has
  // loaded), then upgrades to the real "zip - county" label once
  // updateZipCountiesIfNeeded's mount-time fetch lands.
  get selectedOption() {
    const { value, zipCounties } = this.props

    if (!value) {
      return null
    }

    const [zipCode, fipsCode] = value.split('-')
    const match = (zipCounties || []).find((zc) => zc.zip_code === zipCode && zc.fips_code === fipsCode)

    return { value, label: match ? `${match.zip_code} - ${match.county_name}` : value }
  }

  updateZipCountiesIfNeeded() {
    if (this.props.value && isNil(this.props.zipCounties) && !this.props.requestInProgress) {
      // Fire-and-forget: getZipCounties now rejects on failure, so an uncaught
      // rejection here would otherwise surface as a console error.
      Promise.resolve(this.props.getZipCounties(this.props.value.split('-')[0])).catch(() => {})
    }
  }

  render() {
    return (
      <FormField label="Zip Counties" htmlFor="zip_fips" className={this.props.className}>
        {/* AsyncSearchSelect hardcodes h-12 on its trigger where Select uses h-10;
            override here to match until that's fixed upstream. */}
        <AsyncSearchSelect
          id="zip_fips"
          className="h-10"
          value={this.selectedOption}
          onSearch={this.onSearch}
          aria-label="Zip Counties"
          {...toOptionProps({ name: 'zip_fips', handleChange: this.props.handleChange })}
        />
      </FormField>
    )
  }
}

export default ZipFipsComponent
